import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'EmergencyService',
    controller: 'ExecutTask'
};

const methods = [
    'AddItem',
    'UpdateItem',
    'DelItem',
    'DelItemList',
    'GetItemById',
    'FindByConditions',
    'GetPageContentByConditions',
    'StartTaskManual'
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const ExecutTaskApi = ZJApi.defineNewApi('ExecutTaskApi', factory);

export default ExecutTaskApi;